<template>
  <div>
    <detail-title-con :extractInfo="extractInfo"></detail-title-con>
    <div class="list">
      <div class="list-title" style="display:flex;">
        证据下载列表
        <button @click="goInfo">
         证据提取列表
        </button>
      </div>

      <div class="list-cont">
        <table
          class="table"
          style="white-space: normal;word-break:break-all;margin-top: 20px;width:100%;"
        >
          <thead style=";width: 100%;border-right: 1px solid #d2d2d2;">
            <tr style="background-color: #e4e4e4 !important;width:100%;">
              <td style="width:170px;text-align: center;">下载任务名称</td>
              <td style="width:345px;text-align: center;">证据来源</td>
              <td style="width:170px;text-align: center;">证据数量</td>
              <td style="width:170px;text-align: center;">任务生成时间</td>
              <td style="width:345px;text-align: center;">打包完成时间</td>
              <td style="width:345px;text-align: center;">当前状态</td>
              <td style="width:345px;text-align: center;">操 作</td>
            </tr>
          </thead>
          <tbody
            v-if="downloadList.length"
            class="table-list"
            style="border-right: 1px solid #d2d2d2;border-bottom: 1px solid #d2d2d2;text-align:center;"
          >
            <tr style="height:30px;" v-for="(item,index) in downloadList" :key="index">
              <td v-text="item.name"></td>
              <td>
                <span v-if="item.source == 1">确权</span>
                <span v-else-if="item.source == 2">自主</span>
                <span v-else-if="item.source == 7">公证处</span>
                <span v-else-if="item.source == 8">证据提取</span>
              </td>
              <td v-text="item.amount"></td>
              <td style="width:300px" v-text="item.createTimeFormate"></td>
              <td v-text="item.finishTimeFormate"></td>
              <td class="single-img">
                <img
                  v-if="item.status == 1 || item.status == 4"
                  title="打包中"
                  src="../../assets/images/info/process_icom.png"
                  class="center status"
                />
                <img
                  v-else-if="item.status == 2"
                  title="打包成功"
                  src="../../assets/images/info/success_icom.png"
                  class="center status"
                />
                <img
                  v-else-if="item.status == 3"
                  title="打包失败"
                  src="../../assets/images/info/fail_icon.png"
                  class="center status"
                />
              </td>
              <td class="data-actions" style="width:345px;text-align: center;line-height:10px">
                <a :href="item.downloadLink" v-if="item.status != 1 && item.status != 3 && item.status!=4" download style="display: inline-block;
    margin-left: 4px;">
                  <span class="icon-info-save icon-box" style="left: 20%;" title="保存"></span>
                </a>
                <span class="icon-info-save-disabled icon-box" style="left: 20%;" title="保存" v-else></span>
                <!-- <span
                  class="icon-info-deleted icon-box"
                  title="删除"
                  style="left: 60%;margin-left: 22px;"
                  @click="deleteShare(item)"
                ></span> -->
              </td>
            </tr>
          </tbody>
        </table>
        <div class="noDataBox"  v-if="!downloadList.length">
          <img src="../../assets/images/common/nodata.png" />
          <p>&nbsp;&nbsp;&nbsp;&nbsp;您目前还没有数据...</p>
        </div>
        <paging :pageInfo="pageInfoEvidence" :isAsync="isAsync"></paging>
        <action-modal v-if="$store.state.msgModal.showMsgModal" @selectRes="isClose"></action-modal>
      </div>
    </div>
  </div>
</template>

<script>
import paging from "@/components/common/Paging.vue";
import detailTitleCon from "./detailTitleCon";
import ActionModal from '../common/ActionModals';
export default {
  data() {
    return {
      downloadList: [],
      querylist: {},
      pageInfoEvidence: {},
      extractInfo:{},
      deletedPack:{},
      noDataEvidence: false,
      pageInfo: {
        pageNumber: 1,
        pageSize: 10,
        totalPage: 3,
        totalRow: 30
      },
      isAsync: true,
      isShouldAdd: true
    };
  },
  components: {
    paging,
    detailTitleCon,
    ActionModal
  },
  methods: {
    goInfo() {
      // let querys = JSON.parse(window.sessionStorage.getItem("evdenceQuery"));
      this.$router.push({ path: "detail", query: { ...this.$route.query,pageNumber:1 } });
    },
    isClose(){
      this.$store.commit('showMsgModal', false);
    },
    //获取打包列表
    dowloadListRequest() {
       this.extractInfo=JSON.parse(window.sessionStorage.getItem("extractInfo"))
      this.$store.commit("showLoading", true);
      // 无数据置空
      this.noDataDownload = false;
      // query 情况
      if (this.$route.query.partnerId) {
        // console.log("Dsadasd", this.$router.history.current.path);
        this.queryUrlParams = this.$route.query;
      } else {
        this.queryUrlParams = JSON.parse(
          window.sessionStorage.getItem("evdenceQuery")
        );
      }
    
      let pageNo = this.queryUrlParams.pageNumber
        ? this.queryUrlParams.pageNumber
        : 1;
      let pageSize = this.queryUrlParams.pageSize
        ? this.queryUrlParams.pageSize
        : 10;
      this.$ajax
        .get("/webapi/extractEvidence/downloadList", {
          params: {
            extractingCode: this.queryUrlParams.extractingCode,
            pageSize,
            pageNumber: pageNo,
            pid: this.queryUrlParams.pid,
            partnerId: this.queryUrlParams.partnerId,
            type: this.queryUrlParams.type
          }
        })
        .then(res => {
          if (res.data.code == 200) {
            this.noDataDownload = true;
            this.$store.commit("showLoading", false);
            // 页码信息
            let pageInfo = {};
            pageInfo.pageNumber = res.data.extraData.pageNumber;
            pageInfo.pageSize = res.data.extraData.pageSize;
            pageInfo.totalPage = res.data.extraData.totalPage;
            pageInfo.totalRow = res.data.extraData.totalRow;
            this.pageInfoEvidence = pageInfo;
            // 数据信息
            let list = res.data.extraData.list;
            if (list.length == 0) {
              this.noDataDownload = false;
            }else{
              this.noDataDownload = true;
            }
            list.forEach(item => {
              item.createTimeFormate = this.$moment(item.createTime).format(
                "YYYY-MM-DD HH:mm:ss"
              );
              item.finishTimeFormate = item.finishTime
                ? this.$moment(item.finishTime).format("YYYY-MM-DD HH:mm:ss")
                : "";
              // this.$GlobalConfig.downloadPack.forEach(itemLink=>{
                // if(itemLink.partnerId==this.queryUrlParams.partnerId){
                  // console.log(itemLink,"Dasdasdasdasd")
                  item.downloadLink = item.path;
                  // encodeURI(
                      // itemLink.ip + '/'+item.path + "?name=" +item.name
                    // );
                // }
              // })
            });
            // console.log("下载列表",list)
            // http://101.201.112.127/ip360FileSource/evidencepackage/20180814/807_e69ccc7ed3db4277bd2f23bc3f528fcd.zip?name=ad
            this.downloadList = list;
            // 打包时是否应该打包
            this.isShouldAdd = !list.some(item => {
              return item.status == 2 || item.status == 1;
            });
          }else{
            this.$store.commit("showLoading", false);
            this.$store.dispatch("showMsgModal", {
                autoClose: true,
                info: res.data.message
              });
          }
        });
    },
    // 打包证据
    packEvidence() {
        this.extractInfo=JSON.parse(window.sessionStorage.getItem("extractInfo"))
      // console.log(this.querylist,this.extractInfo,"-----------------------------------------")
      if (this.isShouldAdd) {
        this.$ajax
          .get("/webapi/extractEvidence/packageBatchUrlDownloadSecondLevel", {
            params: {
              source: this.extractInfo &&this.extractInfo.dataSources?this.extractInfo.dataSources:1,
              pid: this.extractInfo &&this.extractInfo?this.extractInfo.id:112,
              type: 1, //1公证处 2证据提取
              extractingCode: this.querylist.extractingCode,
              partnerId: this.querylist.partnerId
            }
          })
          .then(response => {
            if (response.data.code == 200) {
              // 打包中
              this.dowloadListRequest();
            } else {
              this.$store.dispatch("showMsgModal", {
                autoClose: true,
                info: response.data.message
              });
            }
          });
      }
    },
    	isDelete (data) {
        if(!data){
          return;
        }
				this.$store.commit('showLoading', true)
        let queryUrlParams = JSON.parse(window.sessionStorage.getItem("evdenceQuery"))
        this.$ajax.get('/webapi/extractEvidence/removeDownload',{
          params: {
            partnerId: this.queryUrlParams.partnerId,
            taskId: this.deletedPack.id,
            extractingCode:this.queryUrlParams.extractingCode
          }
        }).then(( res ) => {
          this.$store.commit('showLoading', false)
          if (res.data.code == 200) {
            this.dowloadListRequest();
          }else{
            this.$store.dispatch('showMsgModal', {
              autoClose: true,
              info: response.data.msg
            })
          }
        })
			},
     deleteShare (item) {
				this.deletedPack = item
        this.$store.commit('showActionModal',{
          showActionModal:true,
          info: '确认删除？'
        })
    },
    gotoPage(pagingRes){
      // console.log("用户点击的页数",pagingRes)
    }
  },
  created(){
    this.extractInfo=JSON.parse(window.sessionStorage.getItem("extractInfo"))
  },
  mounted() {
    this.querylist = this.$route.query;
    // console.log("证据打包")
     this.dowloadListRequest();
    this.packEvidence();
    if( JSON.parse(window.sessionStorage.getItem("evdenceQuery"))){
        this.querylist=JSON.parse(window.sessionStorage.getItem("evdenceQuery"))
    }else{
       window.sessionStorage.setItem(
       "evdenceQuery",
        JSON.stringify({ ...this.querylist})
      );
    }
  },
		watch:{
			'$route' () {
				// let pos = this.$router.history.current.query.pos;
				// if (pos == 'download') {
					// 下载列表
					this.dowloadListRequest();
				// } else {
				// 	// 证据列表
				// 	this.dataRequst()
				// }
			}
		}
};
</script>

<style scope lang="scss">
@import "../../assets/common/icon.css";
.list {
  margin-top: 10px;
  padding: 20px;
  box-shadow: 0px 5px 10px 0px rgba(177, 177, 178, 0.58);
  border-radius: 4px;
  background: #fff;
  &-title {
    padding-left: 10px;
    border-left: 3px solid #366efc;
    font-size: 16px;
    font-weight: bold;
    color: #323232;
  }
  table.table tr td {
    border-top: 1px solid #d2d2d2;
    border-left: 1px solid #d2d2d2;
  }
  .table {
    width: 100%;
    border-spacing: 0;
    border-collapse: collapse;
  }
  .table tr td {
    color: #888888;
    font-size: 14px;
    vertical-align: middle;
    
  }
  .table > tr:hover,
  .table thead > tr:hover,
  .table tbody > tr:hover {
    background-color: #f1f1f1 !important;
  }

  .table > thead {
    background-color: rgb(210, 210, 210);
  }
  .table > thead td {
    color: #595959;
  }
  .table thead tr {
    height: 38px;
    line-height: 38px;
  }
  .table tbody tr {
    height: 32px;
    line-height: 32px;
  }
  .single-img {
    text-align: center;
    line-height: 10px;
  }
  .icon-box {
    display: inline-block;
    width: 18px;
    height: 18px;
    background-size: contain;
  }
  .list-title {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 22px;
    button {
      width: 100px;
      background: #366efc;
      color: #fff;
      border: 0;
      float: right;
      height: 30px;
      a {
        color: #fff;
      }
    }
    button:hover {
      background: #1f5af0;
    }
  }
  .noDataBox {
    width: 100%;
    text-align: center;
    min-height: 239px;
    border-bottom: 1px solid #ccc;
    border-left: 1px solid #ccc;
    border-right: 1px solid #ccc;
    margin-top: -32px;
    padding-top: 97px;
    box-sizing:border-box;
  }
  .page-box{
    margin-top: 12px;
  }
}
.list .table tbody tr td {
    font-size: 12px;
    line-height: 18px;
    color: #787878;
}
</style>